// ** Handles RTL (Bool)
export const handleRTL = (value: any) => (dispatch: any) => dispatch({ type: 'HANDLE_RTL', value })
